export default __webpack_public_path__ + "static/media/Montserrat-Medium.d6d2a0ba.eot";